const PageSubtitle = ({ children }) => (
  <div className="text-gray-800 dark:text-gray-200 text-xl font-normal">
    {children}
  </div>
);

export default PageSubtitle;
